function contact() {

    var $theForm = $('#new-contact');
    var contactran;

    if( !! $('.contact-lander').length ) {
        getEventsByType()
        .done(function(data) {
            var eventLinks = [];
            $.each(data, function (eventTypeKey, eventType) {
                eventLinks[eventTypeKey] = '';
                var events = _.sortBy(eventType.events, 'title');
                $.each(events, function (eventKey, event) {
                        if(event.contact) {
                            var target = 'target="_blank"';

                            if (event.url == 'https://ultramusicfestival.com/') {
                                target = '';
                            }
                            eventLinks[eventTypeKey] += `<li><a href="${event.contact}" ${target}><img width="15" alt="${event.title} flag" src="${event.media.flag || ultra_settings.images.default_flag}" style="position:relative; top:2px;"> ${event.title_label}</a></li>`;
                        }
                    });
            });
            $('.contacts-1').html(eventLinks['ultra']);
            $('.contacts-2').html(eventLinks['beach']);
            $('.contacts-3').html(eventLinks['rtu']);
            $('.contacts-4').html(eventLinks['resistance']);
        });
    }

    if( !! $('.contact-list').length && !contactran) {

        $(document).on('change', '#select_contacts', function(){

            if ($("option#none_selected:selected").length) {
                return;
            }
            if( $("option#miami_contact:selected").length) {

                $('.form-wrap .disabled, .contact-list').fadeOut(300);

            } else {

                if ($(this).val()) {
                    window.open($(this).val());
                }

            }

        });
        contactran = true;

        var customername = getUrlParam('fullname');
        var customeremail = getUrlParam('passportemail');
        var department = getUrlParam('department');
        var subject = getUrlParam('subject');

        if(customername) {
            $('#guest_name').val(decodeURIComponent(customername));
        }
        $('#guest_email').val(customeremail);
        $('#department').val(department);
        $('#subject').val(subject);

        if(department) {

            $('.form-wrap .disabled, .contact-list').fadeOut(300);
            log('yes dept');
        }

    }

    $theForm.validate({
        rules: {
            "hiddenRecaptcha": {
                required: function() {
                    if(grecaptcha.getResponse() == '') {
                        //log('yes recaptcha');
                        return true;
                    } else {
                        //log('no recaptcha');
                        return false;
                    }
                }
            }
        },
        messages: {
            "hiddenRecaptcha": __('You must prove you are not a robot', 'ultra-2015'),
            "name": __('Please enter your Full name', 'ultra-2015'),
            "email": __('Please enter your Email Address', 'ultra-2015'),
            "department": __('Please select a Department', 'ultra-2015'),
            "subject": __('Please enter a Subject', 'ultra-2015')
        },
        invalidHandler: function(event, validator) {
            log('errors');
        },
        submitHandler: function(form) {
            log('no errors');
            $('#new-contact').append('<div class="sending"></div>');
            $('#thankyou').find('span.guest-name').text($('#new-contact input#name').val());
            setTimeout(function() { form.submit(); }, 500);
            return false;
        }

    });

    $('input#preventer').val('34587gh2398sudfv');

}
